import { useCallback, useEffect } from 'react'
import { useSocketConnection } from './useSocketConnection'
import { IAIVideoSocketMessage } from 'types/aiVideo'
import { IAIImageSocketMessage } from 'types/aiImage'
import { IUserCreditsSocketMessage } from 'types/userCredits'
import {
  handleAiVideoSocketData,
  handleAiVideoPastSocketData
} from 'services/socket/aiVideo'
import { handleAIImgSocketData } from 'services/socket/aiImage'
import { handleUserCreditsSocketData } from 'services/socket/userCredits'
import { ISocketStateRecover } from '../types/socketStateRecover'

export const useAppSockets = () => {
  const enableSocketConnection = useSocketConnection()

  const handleSocketDataByType = useCallback(
    (
      data:
        | IAIVideoSocketMessage
        | IAIImageSocketMessage
        | IUserCreditsSocketMessage
    ) => {
      switch (data.type) {
        case 'ai-video':
          handleAiVideoSocketData(data)
          break
        case 'ai-image':
          handleAIImgSocketData(data)
          break
        case 'user-credits':
          handleUserCreditsSocketData(data)
          break
      }
    },
    []
  )

  const handlePastSocketDataByType = useCallback(
    (
      data: ISocketStateRecover<
        | IAIVideoSocketMessage
        | IAIImageSocketMessage
        | IUserCreditsSocketMessage
      >
    ) => {
      const pastSocketsEventsData = data?.pastSocketsEventsData
      pastSocketsEventsData?.forEach(eventData => {
        if (eventData.type === 'ai-video' || 'gen_ai_video_hash' in eventData) {
          handleAiVideoPastSocketData(eventData)
        }
      })
    },
    []
  )

  useEffect(() => {
    window.updateProgressBar = (
      data:
        | ISocketStateRecover<
            | IAIVideoSocketMessage
            | IAIImageSocketMessage
            | IUserCreditsSocketMessage
          >
        | IAIVideoSocketMessage
        | IAIImageSocketMessage
        | IUserCreditsSocketMessage
    ) => {
      if ('type' in data) {
        handleSocketDataByType(data)
      } else if ('gen_ai_video_hash' in data) {
        handleAiVideoSocketData(data)
      }

      if ('socketType' in data) handlePastSocketDataByType(data)
    }
  }, [handleSocketDataByType, handlePastSocketDataByType])

  useEffect(() => {
    enableSocketConnection()
  }, [enableSocketConnection])
}
